import './clock';
import './carousel';
import './posts/loadmore';
import './zustand';
import './navbar';

// Styles
import '../sass/main.scss';

// Images.
import '../img/cats.jpg';
import '../img/patterns/cover.jpg';
